<div class="transparent-overlay"></div>
<div
  class="walkthrough-overlay"
  [ngStyle]="{height: rect.height + 'px', width: rect.width + 'px', top: rect.top + 'px', left: rect.left + 'px'}"
></div>

<div cdkTrapFocusAutoCapture cdkTrapFocus class="tooltip" [ngClass]="position" [ngStyle]="tooltipPosition">
  <div class="tooltip__header">
    <p class="tooltip__caption">{{ currentStep.heading }}</p>
    <button class="tooltip__close" (click)="stop()">
      <mat-icon aria-hidden="false" svgIcon="cross-black" class="tooltip__close-icon"></mat-icon>
    </button>
  </div>

  @if (progress) {
    <mat-progress-bar [value]="progress" class="tooltip__progress-bar"></mat-progress-bar>
  }

  <div class="tooltip__footer">
    <span class="tooltip__step">Step {{ currentStepNumber }} of {{ stepsCount }}</span>
    <mc-button
      autofocus
      (click)="lastStep ? stop(true) : next()"
      class="tooltip__next-btn"
      variant="link"
      color="primary"
      size="medium"
    >
      {{ lastStep ? 'Complete' : 'Next Step' }}
      <mat-icon
        aria-hidden="true"
        svgIcon="{{ lastStep ? 'check' : 'arrow-right' }}"
        class="tooltip__btn-icon"
        [ngClass]="{completed: lastStep}"
      >
      </mat-icon>
    </mc-button>
  </div>
</div>
